/**
 * Supported Tenants
 *
 * Note: When adding new tenants, make sure to go over all files in this directory to apply the desired logo and
 * tenant name configurations.
 */
export enum Tenant {
  avelios = 'avelios', // default
  sana = 'sana',
}

const defaultTenant = Tenant.avelios;

/**
 * Extracts the configured tenant out of the current environment. Tenants can be set by defining the env variable `NEXT_PUBLIC_TENANT`.
 * If not tenant is defined in the environment, the fallback will be avelios (defeault tenant).
 */
export const TENANT: Tenant = (() => {
  const envTenant = process.env.NEXT_PUBLIC_TENANT;

  if (!envTenant) {
    console.warn(`NEXT_PUBLIC_TENANT not defined. Falling back to ${defaultTenant}`);
    return defaultTenant;
  }

  if (Object.keys(Tenant).includes(envTenant)) {
    return envTenant as Tenant;
  }

  console.warn(`Unknown NEXT_PUBLIC_TENANT ${envTenant}. Falling back to ${defaultTenant}`);
  return defaultTenant;
})();
